// KAN-1342: единственное место, где рождаются ключи кэша чата.
export const conversationKeys = {
  all: ["conversations"] as const,
  list: (archived: boolean) => [...conversationKeys.all, "list", archived] as const,
  lists: () => [...conversationKeys.all, "list"] as const,
  detail: (id: string) => [...conversationKeys.all, "detail", id] as const,
  messages: (id: string) => [...conversationKeys.all, "messages", id] as const,
  search: (id: string, query: string, from?: string, to?: string) => [...conversationKeys.all, "search", id, query, from ?? "", to ?? ""] as const,
  mediaCounts: (id: string) => [...conversationKeys.all, "media-counts", id] as const,
  media: (id: string, kind: string) => [...conversationKeys.all, "media", id, kind] as const,
  pins: (id: string) => [...conversationKeys.all, "pins", id] as const,
  members: (id: string) => [...conversationKeys.all, "members", id] as const,
  scrimOptions: (id: string) => [...conversationKeys.all, "scrim-options", id] as const,
  myLfgCards: () => [...conversationKeys.all, "my-lfg-cards"] as const,
  chatLists: () => [...conversationKeys.all, "chat-lists"] as const,
  blocks: () => [...conversationKeys.all, "blocks"] as const,
  userSearch: (query: string) => [...conversationKeys.all, "user-search", query] as const,
  privacy: () => [...conversationKeys.all, "privacy"] as const,
};
